/** Known enum-style values from asset stats APIs — translate for display only; unknown values pass through. */
const STATS_CHART_LABEL_KEYS = new Set([
  "software",
  "hardware",
  "services",
  "virtual_machine",
  "information_assets",
  "network_assets",
  "organizational_people_assets",
  "facilities",
  "documentation_assets",
  "active",
  "inactive",
  "retired",
  "pending",
  "in_maintenance",
]);

export function normalizeStatsChartLabelKey(raw) {
  return String(raw ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s/-]+/g, "_");
}

export function translateStatsChartLabel(raw, t) {
  const key = normalizeStatsChartLabelKey(raw);
  if (!key) return String(raw ?? "");
  if (STATS_CHART_LABEL_KEYS.has(key)) {
    return t(`assetManagement.statsPage.chartLabels.${key}`);
  }
  return String(raw ?? "");
}
